const labels = {
  darkMode: "Mode sombre",
  lightMode: "Mode clair",
};

export default labels;
